import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useCallback, useMemo, useState } from 'react';
const GRADIENT_STOPS = 'transparent 135deg, var(--accent-fg-primary) 180deg, transparent 225deg';
export const DictationBorderOverlay = React.memo(function DictationBorderOverlay({ active, borderRadius, }) {
    const [aspectRatio, setAspectRatio] = useState(1);
    const measureRef = useCallback((node) => {
        if (node !== null) {
            setAspectRatio(node.clientWidth / node.clientHeight);
        }
    }, []);
    const gradientStyles = useMemo(() => ({
        ['--button-border-gradient-stops']: GRADIENT_STOPS,
        ['--button-aspect-ratio']: aspectRatio,
        ['--button-aspect-ratio-multiplier']: 0.65,
        transform: 'translateY(-50%) scaleX(calc(var(--button-aspect-ratio) * var(--button-aspect-ratio-multiplier)))',
    }), [aspectRatio]);
    // Reveals only the 1px border ring: mask-composite punches out the interior,
    // so the (transparent) input shows through cleanly and the gradient never
    // fills the box.
    const ringMaskStyles = useMemo(() => ({
        borderRadius,
        padding: 1,
        WebkitMask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
        WebkitMaskComposite: 'xor',
        mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
        maskComposite: 'exclude',
    }), [borderRadius]);
    return (_jsx("div", { ref: measureRef, "aria-hidden": true, 
        // Above the input (which is opaque and would otherwise hide the ring);
        // pointer-events-none + the 1px mask keep it inert and text-safe.
        className: classNames('pointer-events-none absolute inset-0 z-[2] transition-opacity duration-300', active ? 'opacity-100' : 'opacity-0'), style: { borderRadius }, children: _jsx("div", { className: "absolute inset-0 overflow-hidden", style: ringMaskStyles, children: _jsx("div", { style: gradientStyles, className: "absolute inset-0 top-1/2 flex size-full items-center justify-center will-change-transform", children: _jsx("div", { style: { animation: active ? 'spin 5s linear infinite' : 'none' }, className: "absolute aspect-square min-h-full w-full origin-center bg-[conic-gradient(var(--button-border-gradient-stops))] blur-sm" }) }) }) }));
});
//# sourceMappingURL=DictationBorderOverlay.js.map